import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-dairy-menu',
  templateUrl: './case-dairy-menu.component.html',
  styleUrls: ['./case-dairy-menu.component.css']
})
export class CaseDairyMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component.ts